import React from 'react';
import { Wrench, Leaf, Clock, Mail, Phone } from 'lucide-react';
import './MaintenancePage.css';

const MaintenancePage = () => {
  return (
    <div className="maintenance-page">
      <div className="maintenance-background">
        <div className="maintenance-leaf maintenance-leaf-1"></div>
        <div className="maintenance-leaf maintenance-leaf-2"></div>
        <div className="maintenance-leaf maintenance-leaf-3"></div>
        <div className="maintenance-leaf maintenance-leaf-4"></div>
      </div>
      
      <div className="maintenance-container">
        <div className="maintenance-card">
          <div className="maintenance-icon-wrapper">
            <div className="maintenance-icon-circle">
              <Wrench className="maintenance-icon" size={48} />
            </div>
            <div className="maintenance-leaf-accent">
              <Leaf size={24} />
            </div>
          </div>
          
          <h1 className="maintenance-title">
            We're Nurturing Our Garden
          </h1>
          
          <p className="maintenance-subtitle">
            Our system is currently under maintenance to bring you a better experience.
          </p>
          
          <div className="maintenance-info">
            <div className="maintenance-info-item">
              <Clock size={20} />
              <span>We'll be back</span>
            </div>
          </div>
          
          <div className="maintenance-divider"></div>
          
          <div className="maintenance-contact">
            <p>Need immediate assistance?</p>
            <div className="maintenance-contact-links">
              <a href="mailto:batino50@gmail.com" className="maintenance-contact-link">
                <Mail size={16} />
                batino50@gmail.com
              </a>
              <a href="tel:+639564415764" className="maintenance-contact-link">
                <Phone size={16} />
                +63 956 441 5764
              </a>
              <a href="tel:+639676791319" className="maintenance-contact-link">
                <Phone size={16} />
                +63 967 679 1319
              </a>
            </div>
          </div>
          
          <div className="maintenance-footer">
            <div className="maintenance-logo">
              <Leaf size={20} />
              <span>Batino's Garden</span>
            </div>
            <p>Thank you for your patience!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;

